import styled from 'styled-components';

export const MultipleInvitationsContainer = styled.div`
    padding: 1em;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: .5em;
`;